<template>
  <div class="material repeating-fields">
    <CRow>
      <CCol><h5 class="font-weight-bold" style="font-size: 1rem;">Material</h5></CCol>
    </CRow>
    <CRow v-if="isMaterialCatalogVisible" class="align-items-stretch mb-2">
      <CCol md="8" lg="9">
        <MaterialKatalogAuswahl
          v-model="selectedCatalogMaterial"
          form-label="Materialkatalog"
          form-label-class="d-block mb-0"
          rules=""
          @input="addCatalogMaterial"
        />
      </CCol>
      <CCol md="4" lg="3" class="d-flex align-items-center justify-content-center">
        <button
          type="button"
          class="material-add-inline"
          @click="addEntry()"
        >
          <span class="material-add-inline__icon">+</span>
          <span>Material hinzufügen</span>
        </button>
      </CCol>
    </CRow>
    <CRow class="labels" style="margin-left: 1rem;">
      <CCol class="d-none d-md-block col-md-2">
        Stück*
      </CCol>
      <CCol class="d-none d-md-block col-md-3">
        Art.-Nr.
      </CCol>
      <CCol class="d-none d-md-block col-md-7">
        Material
      </CCol>
    </CRow>
    <VueRepeaterLocal v-model="materialListe" identifier="formular-material"/>
    <div class="vorgaben mt-2 px-0">
      <CRow class="mt-2 border pl-1 pr-3 py-1 pt-2 mx-0" v-for="(item, index) in materialVorgabe" v-bind:key="index">
        <CCol class="col-10 px-0">
          <CRow>
            <CCol class="col-8 col-md-2 px-0">
              <MaterialText
                class=""
                form-label=""
                v-bind:value="item.stueckzahl"
                :isValid="true"
                disabled="disabled"
              />
            </CCol>
            <CCol class="d-none d-md-block px-0 col-md-3">
              <MaterialText
                :isValid="true"
                form-label=""
                rules=""
                placeholder="Artikel Nr."
                disabled="disabled"
              />
            </CCol>
            <CCol class="col-12 col-md-6 px-0">
              <MaterialText
                form-label=""
                v-bind:value="item.material"
                :isValid="true"
                disabled="disabled"
              />
            </CCol>
          </CRow>
        </CCol>

        <CCol class="col-2 text-right m-auto">
          <CButton
            color="danger"
            variant="outline"
            size="sm"
            class="ml-2 vertical-align-middle m-auto"
            v-c-tooltip="{content: 'Löschen', placement:'left'}"
            v-on:click="deleteEntry(item.id)"
            v-if="!item.aktiv"
          >
            <CIcon name="cil-trash"/>
          </CButton>
        </CCol>
      </CRow>
      <CRow>
        <CCol class="col-4"><h5 class="font-weight-bold" style="font-size: 1rem;"></h5></CCol>
        <CCol class="col-8 py-2 px-0 mx-0 right text-right">
          <CButton
            color="success"
            size="sm"
            class="right text-right"
            @click="addEntry()"
            v-c-tooltip="{content: 'Hinzufügen', placement:'left'}"
          >
            Material hinzufügen
            <CIcon name="cil-library-add"/>
          </CButton>
        </CCol>
      </CRow>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { EventBus } from '@/helpers/eventBus'
import MaterialKatalogAuswahl from '@/components/MaterialKatalogAuswahl'
import VueRepeaterLocal from '@/components/VueRepeater/VueRepeaterLocal'
import MaterialText from '@/components/FormElements/Text'

export default {
  name: 'ProtokollMaterial',
  components: {
    MaterialKatalogAuswahl,
    VueRepeaterLocal,
    MaterialText
  },
  props: {
    value: {
      type: Array,
      required: false
    },
    materialVorgabe: {
      type: Array,
      required: false
    }
  },
  data () {
    return {
      bus: new Vue(),
      selectedCatalogMaterial: null,
      materialListe: []
    }
  },
  computed: {
    isMaterialCatalogVisible () {
      return process.env.VUE_APP_ENABLE_PROTOKOLL_MATERIAL_CATALOG !== 'false'
    }
  },
  mounted () {
    if (this.value) {
      const self = this
      this._.forEach(this.value, function (v) {
        self.materialListe.push({
          name: 'formular-material',
          value: v
        })
      })
    }
  },
  watch: {
    materialListe: function () {
      const results = []
      const copyMaterialListe = Object.assign(this.materialListe)
      this._.forEach(copyMaterialListe, function (mtrl) {
        if (mtrl.value) {
          const value = mtrl.value
          results.push({
            ...value,
            artikelnr: typeof value.artikelnr === 'string' ? value.artikelnr.trim() : value.artikelnr,
            material: typeof value.material === 'string' ? value.material.trim() : value.material
          })
        }
      })
      this.$emit('input', results)
    }
  },
  methods: {
    addEntry: function () {
      EventBus.$emit('addRowMaterial', 'formular-material')
    },
    addCatalogMaterial (catalogMaterial) {
      if (!catalogMaterial || catalogMaterial.materialid === 'no-result') {
        return
      }

      // Later import will populate the same catalog endpoint, so the add flow stays unchanged.
      EventBus.$emit('addRowMaterial', 'formular-material', {
        stueckzahl: '',
        artikelnr: catalogMaterial.artikelnr || '',
        material: catalogMaterial.material || '',
        qtySuggestions: this.mergeQuantitySuggestions(catalogMaterial)
      })
      this.selectedCatalogMaterial = null
    },
    mergeQuantitySuggestions (catalogMaterial) {
      const primarySuggestions = Array.isArray(catalogMaterial.qtysuggestions) ? catalogMaterial.qtysuggestions : []
      const recentSuggestions = Array.isArray(catalogMaterial.recentqtysuggestions) ? catalogMaterial.recentqtysuggestions : []
      const seenSuggestions = {}

      return primarySuggestions.concat(recentSuggestions).filter((value) => {
        const normalizedValue = String(value || '').trim()
        if (normalizedValue === '' || seenSuggestions[normalizedValue]) {
          return false
        }

        seenSuggestions[normalizedValue] = true
        return true
      })
    },
    deleteEntry: function (vorgabenid) {
      // eslint-disable-next-line vue/no-mutating-props
      const arrayid = Vue._.findIndex(this.materialVorgabe, function (i) { return i.id === vorgabenid })
      if (arrayid !== -1) {
        // eslint-disable-next-line vue/no-mutating-props
        this.materialVorgabe.splice(arrayid, 1)
      }
    }
  }
}
</script>

<style lang="scss">
  .repeater-drop-zone:first-child button[title="Remove block"]{
    display: none !important;
  }

  .material-add-inline {
    appearance: none;
    background: #f5f6f8;
    border: 1px solid #d8dbe0;
    border-radius: 999px;
    color: #6c757d;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.35rem;
    font-weight: 500;
    min-height: 2.5rem;
    padding: 0.55rem 0.95rem;
    transition: color 0.15s ease, border-color 0.15s ease, background-color 0.15s ease;
  }

  .material-add-inline:hover,
  .material-add-inline:focus {
    color: #000;
    background: #eceef1;
    border-color: #c5c9d0;
    outline: none;
    text-decoration: none;
  }

  .material-add-inline__icon {
    font-size: 1.25rem;
    line-height: 1;
    font-weight: 600;
  }

  div.vorgaben {
    div.row {
      padding-right: 15px;
      padding-left: 15px;
      div.col-sm-2 {
      }
    }
  }
</style>
